import { render, staticRenderFns } from "./highVarianceReport.vue?vue&type=template&id=0496ea06&scoped=true&"
import script from "./highVarianceReport.vue?vue&type=script&lang=js&"
export * from "./highVarianceReport.vue?vue&type=script&lang=js&"
import style0 from "./highVarianceReport.vue?vue&type=style&index=0&id=0496ea06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496ea06",
  null
  
)

export default component.exports